import { Page } from "@/models/page-models/Page";

export const OpenQuotations: Page = {
  "path": "open-quotations",
  "name": "Open Quotations",
  "props": {
    "data":{
      "title": "Open Quotations",
      "printable": "FALSE",
      "url": "open-quotations",
      "groups": [
        {
          "groupItems": [
            {
              "name": "1",
              "pageItems": [
                {
                  "type": "dropdown",
                  "variable": "formData.groups",
                  "label": "Select Group",
                  "disabled": "FALSE",
                  "items": "fetchedData.customerGroups.data",
                  "itemText": "name",
                  "itemValue": "_id",
                  "multiple": true
                },
                {
                  "type": "button",
                  "label": "Update",
                  "onClick": [
                    {
                      "executionOrder": 1,
                      "pageFunction": {
                        "name": "getOpenQtReport",
                        "type": "fnGetData",
                        "arg1Key": "apiUrl",
                        "arg1Value": "/api/v1/quotation/open-quotations-report",
                        "arg2Key": "storeInVar",
                        "arg2Value": "fetchedData.openQtReportValues",
                        "arg3Key": "postData",
                        "arg3Value": "formData"
                      },
                      "name": "getOpenQtReport"
                    }
                  ],
                  "disabled": "FALSE",
                  "color": "primary"
                }
              ],
              "showIf": "fn(LOGICAL,fn(MATCH_ROLE,General Manager),||,fn(MATCH_ROLE,Sales | Manager))"
            },
            {
              "name": "2",
              "pageItems": [
                {
                  "type": "salesFunnel",
                  "showIf": "{{fetchedData.openQtReportValues.data}}",
                  "salesFunnelVariable": "fetchedData.openQtReportValues.data",
                  "funnelType": "Open"
                }
              ]
            }
          ],
          "type": "genericGroup"
        }
      ],
      "useMaxPageWidth": true
    },
    "initialFunctionsCalled": [
      {
        "executionOrder": 2,
        "pageFunction": {
          "name": "getOpenQtReport",
          "type": "fnGetData",
          "arg1Key": "apiUrl",
          "arg1Value": "/api/v1/quotation/open-quotations-report",
          "arg2Key": "storeInVar",
          "arg2Value": "fetchedData.openQtReportValues",
          "arg3Key": "postData",
          "arg3Value": "formData"
        },
        "name": "getOpenQtReport"
      },
      {
        "executionOrder": 2,
        "pageFunction": {
          "name": "getCustomerGroups",
          "type": "fnGetData",
          "arg1Key": "apiUrl",
          "arg1Value": "/api/v1/businesspartnergroups",
          "arg2Key": "storeInVar",
          "arg2Value": "fetchedData.customerGroups"
        },
        "name": "getCustomerGroups",
        "executeIf": "fn(LOGICAL,fn(MATCH_ROLE,General Manager),||,fn(MATCH_ROLE,Sales | Manager))"
      }
    ],
    "functions": []
  },
  "forRole": "SALES_MANAGER,SALES_ACCOUNT_EXECUTIVE,GENERAL_MANAGER",
  "visible": true,
  "routerPriority": 30,
  "menuGroup": "Reports"
}